// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar_bu_QIq","is-children":"is-children_NyIZbS"};